module.exports = __webpack_public_path__ + "img/wp1 (1)-min.10260192.png";